export const PULL_SQP = 'PULL_SQP';
export const SET_SQP = 'SET_SQP';
export const SET_SQP_LOADING = 'SET_SQP_LOADING';
export const PULL_SQP_STATUS = 'PULL_SQP_STATUS';
export const SET_SQP_STATUS = 'SET_SQP_STATUS';
export const SET_SQP_ACCOUNTS_STATUSES = 'SET_SQP_ACCOUNTS_STATUSES';
export const SET_SQP_VIEW_TYPE = 'SET_SQP_VIEW_TYPE';
export const PULL_MISSED_KEYWORDS = 'PULL_MISSED_KEYWORDS';
export const SET_MISSED_KEYWORDS = 'SET_MISSED_KEYWORDS';

export const pullSqpAction = payload => ({ type: PULL_SQP, payload });
export const setSqpAction = payload => ({ type: SET_SQP, payload });
export const setSqpLoadingAction = payload => ({ type: SET_SQP_LOADING, payload });
export const pullSqpStatusAction = payload => ({ type: PULL_SQP_STATUS, payload });
export const setSqpStatusAction = payload => ({ type: SET_SQP_STATUS, payload });
export const setSqpAccountsStatusesAction = payload => ({
  type: SET_SQP_ACCOUNTS_STATUSES,
  payload
});
export const setSqpViewTypeAction = payload => ({ type: SET_SQP_VIEW_TYPE, payload });
export const pullMissedKeywordsAction = payload => ({ type: PULL_MISSED_KEYWORDS, payload });
export const setMissedKeywordsAction = payload => ({ type: SET_MISSED_KEYWORDS, payload });
